import React, { useMemo } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { SELECT_PAYMENT_METHOD_BUTTON_KEYS } from '../../translationKeys';
import './style.scss';

export const SelectPaymentMethodButton = ({
  enabled = false,
  onClick,
}) => {
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(SELECT_PAYMENT_METHOD_BUTTON_KEYS),
    [translationMapper],
  );

  if (!enabled) return null;

  const buttonText = translatedTexts.SELECT_METHOD_BUTTON;

  return (
    <button
      type="button"
      className="QRLinkingSelectPaymentMethodButton"
      onClick={onClick}
    >
      <span className="QRLinkingSelectPaymentMethodButton__label">
        {buttonText}
      </span>
    </button>
  );
};

export default SelectPaymentMethodButton;
